import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

const Input = styled.input`
  width: 100%;
  padding: 0.8rem 0 0.8rem 1rem;
  display: block;

  &[type='number'] {
    padding-right: 1rem;
  }
  
  &:hover {
    border: 1px black solid;
  }
  
  &:focus {
    outline: none;
  }
  
  &:disabled {
    cursor: default;
    background: #555;
  }
  
  /* Apply theme styles only when not using blank skin */
  ${({ theme }) => theme.name !== 'blank' && css`
    width: ${theme.form.input.width || '100%'};
    padding: ${theme.form.input.padding || '0.8rem 0 0.8rem 1rem'};
    border: ${theme.form.input.border || '1px solid #ced4da'};
    border-radius: ${theme.form.input.borderRadius || '0.25rem'};
    
    &:hover {
      border: ${theme.form.input.hover.border || '1px black solid'};
    }
    
    &:focus {
      outline: ${theme.form.input.focus.outline || 'none'};
      border-color: ${theme.form.input.focus.borderColor || '#80bdff'};
      box-shadow: ${theme.form.input.focus.boxShadow || '0 0 0 0.2rem rgba(0, 123, 255, 0.25)'};
    }
    
    &:disabled {
      cursor: default;
      background: ${theme.form.input.disabled.background || '#555'};
    }
  `}
`;

/* eslint-disable-next-line */
export const TextField = forwardRef((props, ref) => <Input {...props} ref={ref} />);

export default TextField;

